import React from "react";
import { BillingFormValues, Country } from "@ecologi/shared";
import { BillingDetailsForm } from "../../BillingDetailsForm";
import { Step2Props, BillingAddress } from "../types";
import { StepTitle } from "./styles";

export const Step2BillingAddress = ({
  formData,
  defaultCountry,
  onContinue,
  onBack,
}: Step2Props) => {
  const initialValues: BillingFormValues = {
    billingAddress1: formData.billingAddress.address1,
    billingAddress2: formData.billingAddress.address2,
    billingCity: formData.billingAddress.city,
    billingPostcode: formData.billingAddress.postcode,
    billingCountry: formData.billingAddress.country || defaultCountry,
    billingCompanyName: "",
    billingEmail: "",
  };

  const handleSubmit = async (values: BillingFormValues): Promise<void> => {
    const billingAddress: BillingAddress = {
      address1: values.billingAddress1,
      address2: values.billingAddress2,
      city: values.billingCity,
      postcode: values.billingPostcode,
      country: values.billingCountry as Country | "",
      companyName: "",
    };
    onContinue(billingAddress);
  };

  return (
    <>
      <StepTitle use="dashboardTitle2" as="h2">
        Billing address
      </StepTitle>

      <BillingDetailsForm
        initialValues={initialValues}
        onGuestSubmit={handleSubmit}
        requireBillingAddress
        submitButtonText="Continue"
        actionType="primary"
        buttonPlacement="right"
      />
    </>
  );
};
